<template>
    <transition name="el-zoom-in-top">
        <div  class="login-wrapper">
            <div class="logo-main">
                <div class="m-login__logo">
                    <a href="#">
                        <img src="">
                    </a>
                </div>
                <h3 class="m-login__title">
                    登录选型宝后台
                </h3>
                <el-form :model="loginForm" :rules="rules2" ref="loginForm" label-position="left" label-width="0px" class="loginForm login-container">
                    <el-form-item prop="account">
                        <el-input type="text"  auto-complete="off" placeholder="手机" v-model="username" @keyup.enter.native="handleKeyEnter"></el-input>
                    </el-form-item>
                    <el-form-item prop="checkPass">
                        <el-input type="password" auto-complete="off" placeholder="密码" v-model="password" @keyup.enter.native="handleKeyEnter"></el-input>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-checkbox v-model="checked"  class="remember">记住我</el-checkbox>
                        <a href="" class="forget-pswd">忘记密码</a>
                    </el-form-item> -->
                    <el-form-item style="width:100%;">
                        <el-button type="" :loading="logining" @click="handleLogin" ref="loginBtn">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </transition>
</template>
<script>
// import axios from 'axios'
export default {
  name: 'Login',
  data: function () {
    return {
      username: '',
      password: '',
      checked: true
    }
  },
  methods: {
    handleLogin () {
      const {username, password, checked} = this
      if (!username || !password) {
        this.$message.error('请正确填写用户名及密码')
        return false
      }
      this.$store.dispatch('AUTH_REQUEST', {username, password, checked})
        .then(res => {
          this.$router.push('/')
        })
        .catch(err => {
          this.$message.error(err.message)
        })
    },
    handleKeyEnter (e) {
      this.handleLogin()
    }
  },
  mounted () {
    //
  }
}
</script>
<style lang="sass">
    @import "~sass/custom/login"
</style>



// WEBPACK FOOTER //
// UserLogin.vue?dd1456ec